/* eslint-disable */
import * as THREE from 'three'
import r1 from '@/oceanSchool/r1.js'

var r = function () {
  function n() {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, n),
      this.items = [];
    var e = new THREE.LoadingManager;
    e.onLoad = function () { }
      ,
      this.loader = new THREE.TextureLoader(e)
  }
  return r1(n, null, [{
    key: "create",
    value: function () {
      n.instance || (n.instance = new n)
    }
  }, {
    key: "add",
    value: function (e, t) {
      n.instance.items.push({
        slug: e,
        texture: t
      })
    }
  }, {
    key: "get",
    value: function (e) {
      return new THREE.TextureLoader().load(e)
      // for (var t = 0; t < n.instance.items.length; t++)
      //   if (n.instance.items[t].slug === e)
      //     return n.instance.items[t].texture
    }
  }, {
    key: "load",
    value: function (t, e) {
      n.instance.loader.load(e, function (e) {
        return n.add(t, e),
          e
      }, function (e) { }, function (e) { })
    }
  }]),
    n
}();

var t = { default: r }

export default t
